var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3672 12.9314H0.596391C0.267442 12.9314 0 13.2009 0 13.5278V14.3237C0 14.6526 0.269551 14.92 0.596391 14.92H11.363C11.6919 14.92 11.9594 14.6505 11.9594 14.3237V13.5278C11.9658 13.1967 11.6962 12.9314 11.3672 12.9314Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56479 11.8639C5.68153 11.9806 5.83434 12.04 5.98501 12.04C6.13782 12.04 6.29063 11.9806 6.40524 11.8639L10.4844 7.78473C10.7157 7.55341 10.7157 7.17564 10.4844 6.94004L9.91983 6.3755C9.68848 6.14415 9.31071 6.14415 9.07514 6.3755L6.97827 8.47451V0.596391C6.97827 0.267415 6.70872 0 6.38191 0H5.58601C5.25707 0 4.98962 0.265278 4.98962 0.596391V8.47662L2.89065 6.37761C2.6593 6.14629 2.27941 6.14629 2.04596 6.37761L1.48141 6.94215C1.25009 7.17347 1.25009 7.55339 1.48141 7.78684L5.56479 11.8639Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconWhite);
export default __webpack_public_path__ + "static/media/download-icon-white.a9bdf17f8871ec6d7d7e3520f7d90e9f.svg";
export { ForwardRef as ReactComponent };